"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACIAL_RECOGNITION_DEVICE_LOCKED_OUT = exports.FACIAL_RECOGNITION_VERIFIED = exports.FACIAL_RECOGNITION_REQUIRED = exports.FACIAL_RECOGNITION = void 0;
// Display wording only. SDK calls, storage keys and stored fields keep the vendor name.
exports.FACIAL_RECOGNITION = "Facial Recognition";
exports.FACIAL_RECOGNITION_REQUIRED = "".concat(exports.FACIAL_RECOGNITION, " Required");
exports.FACIAL_RECOGNITION_VERIFIED = "".concat(exports.FACIAL_RECOGNITION, " Verified");
exports.FACIAL_RECOGNITION_DEVICE_LOCKED_OUT = "This device is locked out of ".concat(exports.FACIAL_RECOGNITION, ".");
